export default __webpack_public_path__ + "static/media/logo.626ac1b0.svg";